/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProgressBarLineComponent} from './progress-bar-line.component';

@NgModule({
    declarations: [ProgressBarLineComponent],
    exports: [
        ProgressBarLineComponent
    ],
    imports: [
        CommonModule
    ]
})
export class ProgressBarLineModule {
}
